<template>
  <div :class="{ 'mobile-bg': isMobile }">
    <SEOHead :title="seoData.title" :description="seoData.description" :keywords="seoData.keywords"
      :structured-data="seoData.structuredData" />
    <AboutPC v-if="!isMobile" />
    <AboutMobile v-else />
  </div>
</template>

<script>
import AboutPC from './AboutPC.vue'
import AboutMobile from './AboutMobile.vue'
import SEOHead from '@/components/SEOHead.vue'
import responsive from '@/utils/responsive'

export default {
  components: { AboutPC, AboutMobile, SEOHead },
  data() {
    return {
      responsive,
      seoData: {
        title: '关于智寰科技 - AI人工智能技术研发公司 | 企业介绍',
        description: '智寰科技专注人工智能核心技术研发与应用，致力于助力企业智能化升级。公司为各行业量身打造智能化解决方案，通过实现自动化管理与智能决策，有效提升效率、降低成本。',
        keywords: '智寰科技,关于智寰科技,人工智能公司,AI技术研发,企业智能化升级,智能化解决方案,计算机视觉,深度学习,图形学',
        structuredData: {
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于智寰科技",
          "description": "智寰科技专注人工智能核心技术研发与应用，致力于助力企业智能化升级",
          "url": "https://zhihuanai.com/about",
          "mainEntity": {
            "@type": "Organization",
            "name": "智寰科技",
            "description": "专注人工智能（AI）核心技术（计算机视觉、深度学习、图形学）研发与应用，致力于助力企业智能化升级",
            "foundingDate": "2020",
            "industry": "人工智能",
            "areaServed": "中国",
            "mission": "智寰科技让营销更简单",
            "vision": "数智化服务引领者",
            "businessPhilosophy": "持续创新+技术突破+商业落地",
            "positioning": "成为世界领先的智能交互技术产品与服务提供商",
            "knowsAbout": ["计算机视觉", "深度学习", "图形学", "人工智能", "智能客服"],
            "hasCredential": "央视权威背书及国家级媒体资源",
            "statistics": [
              {
                "@type": "PropertyValue",
                "name": "连接设备",
                "value": "45600+"
              },
              {
                "@type": "PropertyValue",
                "name": "注册用户",
                "value": "3500+"
              },
              {
                "@type": "PropertyValue",
                "name": "日上传数据量",
                "value": "268万+"
              },
              {
                "@type": "PropertyValue",
                "name": "释放人力",
                "value": "60%"
              },
              {
                "@type": "PropertyValue",
                "name": "客户满意度",
                "value": "98.5%"
              },
              {
                "@type": "PropertyValue",
                "name": "问题处理率",
                "value": "95.14%"
              }
            ]
          }
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.responsive.isMobile
    }
  }
}
</script>

<style scoped>
.page-content {
  text-align: center;
}

/* 移动端背景色 */
.mobile-bg {
  background-color: #F5F7FB;
}
</style>